// ---------------------------------------------------------------------------
// MOTO LUXE — editable site content.
// Update service names, prices, descriptions, testimonials and images here.
// ---------------------------------------------------------------------------

export const BRAND = {
  name: "MOTO LUXE",
  tagline: "MOTORCYCLE DETAILING",
  website: "motoluxe.co.nz",
  owner: "Carlos",
  phone: "020 417 44762",
  phoneHref: "tel:+6402041744762",
  email: "motoluxenz@gmail.com",
  location: "Manawatū, New Zealand",
  facebook: "https://www.facebook.com/profile.php?id=61595194430480",
};

export const LOGO = "/moto-luxe-logo.png";

export const IMAGES = {
  hero:
    "https://static.prod-images.emergentagent.com/jobs/872bb957-a133-4a67-a106-56bf7fb737d8/images/548d5f3225cde06a9ef3404fc9dc49a7c049ef93c5f177ad827a2823884bf886.jpeg",
  intro:
    "https://images.unsplash.com/photo-1656420731047-3eb41c9d1dee?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwyfHxjaW5lbWF0aWMlMjBtb3RvcmN5Y2xlJTIwZGFyayUyMGRyYW1hdGljJTIwbGlnaHRpbmd8ZW58MHx8fHwxNzg2OTE2NjA4fDA&ixlib=rb-4.1.0&q=85&w=1400",
  compare:
    "https://images.unsplash.com/photo-1656420731892-a4ece094df5a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHw0fHxjaW5lbWF0aWMlMjBtb3RvcmN5Y2xlJTIwZGFyayUyMGRyYW1hdGljfGVufDB8fHx8MTc4NjkxNjYwOHww&ixlib=rb-4.1.0&q=85&w=1600",
  ctaBanner:
    "https://images.unsplash.com/photo-1656420731611-ffae337fab6a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwxfHxjaW5lbWF0aWMlMjBtb3RvcmN5Y2xlJTIwZGFyayUyMGRyYW1hdGljfGVufDB8fHx8MTc4NjkxNjYwOHww&ixlib=rb-4.1.0&q=85&w=1600",
};

export const SERVICES_TAGLINE =
  "From a quick wash to full paint correction and ceramic protection, we have a motorcycle detailing package to suit every ride and budget.";

export const SERVICES = [
  {
    id: "quick-ride-refresh",
    name: "Quick Ride Refresh",
    tier: "Budget Package",
    price: "$75",
    description:
      "A fast clean-up to keep your motorcycle looking fresh between full details.",
    features: [
      "Foam wash",
      "Hand contact wash and elbow grease on required areas",
      "Quick dry",
      "Spray wax",
      "Tyres and exterior surfaces wiped down",
    ],
    image:
      "https://images.unsplash.com/photo-1656420731611-ffae337fab6a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwxfHxjaW5lbWF0aWMlMjBtb3RvcmN5Y2xlJTIwZGFya3xlbnwwfHx8fDE3ODY5MTY2MDh8MA&ixlib=rb-4.1.0&q=85&w=900",
  },
  {
    id: "showroom-shine",
    name: "Showroom Shine",
    tier: "Standard Package",
    price: "$175",
    featured: true,
    description:
      "A deeper clean and polish to restore gloss and improve the appearance of paint, chrome and metalwork.",
    features: [
      "Foam wash",
      "Thorough hand contact wash and elbow grease",
      "Dry rub-down",
      "Decontamination wash",
      "Stage 1 paint cut and polish",
      "Metal and chrome polish",
      "Paint sealant wax",
      "Final inspection and wipe-down",
    ],
    image:
      "https://customer-assets-lqy194kg.emergentagent.net/job_elite-bike-shine/artifacts/ku756f98_Image_20260826131735_155_1.png",
  },
  {
    id: "ultimate-motorcycle-detail",
    name: "Ultimate Motorcycle Detail",
    tier: "Premium Package",
    price: "$350",
    description:
      "Our most comprehensive detail — a deep clean, paint correction and long-lasting protection.",
    features: [
      "Full degrease",
      "Foam wash",
      "Thorough hand contact wash and elbow grease",
      "Blow dry",
      "Decontamination wash",
      "Clay bar treatment",
      "Stage 1 cut and polish",
      "Stage 2 refinement polish",
      "Paint sealant wax",
      "Ceramic rub-down protection",
      "Metal and chrome polish",
      "Final inspection and presentation wipe-down",
    ],
    image:
      "https://images.unsplash.com/photo-1596466588448-6e6ceb1da41c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwyfHxtb3RvcmN5Y2xlJTIwZGV0YWlsaW5nJTIwY2hyb21lfGVufDB8fHx8MTc4NjkxNjYwOHww&ixlib=rb-4.1.0&q=85&w=900",
  },
];

export const SERVICES_NOTES = [
  "Pricing may vary depending on the motorcycle's size, condition, level of dirt and amount of chrome.",
  "Heavy grease, oxidation, rust, tar, stains or neglected paint may incur an additional charge.",
  "Prices are based on motorcycles in reasonably accessible condition.",
  "The ceramic rub-down provides surface protection but is not the same as a professionally applied ceramic coating.",
  "Additional services such as engine detailing, leather conditioning, scratch removal or rust treatment can be quoted separately.",
];

export const PILLARS = [
  {
    n: "01",
    title: "Precision",
    text: "Every motorcycle is treated with careful, deliberate attention to detail.",
  },
  {
    n: "02",
    title: "Premium Finish",
    text: "Focused on achieving a deep, refined and showroom-quality appearance.",
  },
  {
    n: "03",
    title: "Passion for Motorcycles",
    text: "Built specifically around motorcycles and the people who ride them.",
  },
  {
    n: "04",
    title: "Quality Over Speed",
    text: "The goal is not simply to clean a motorcycle — it is to make it look exceptional.",
  },
];

export const PROCESS = [
  { n: "01", title: "Inspect", text: "Every motorcycle is assessed before detailing begins." },
  { n: "02", title: "Prepare", text: "Surfaces are carefully prepared for the detailing process." },
  { n: "03", title: "Detail", text: "Every component is meticulously cleaned and finished." },
  { n: "04", title: "Reveal", text: "The motorcycle leaves refined, refreshed and ready to ride." },
];

export const GALLERY = [
  {
    src: "https://images.unsplash.com/photo-1596466588448-6e6ceb1da41c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwyfHxtb3RvcmN5Y2xlJTIwZGV0YWlsaW5nJTIwY2hyb21lfGVufDB8fHx8MTc4NjkxNjYwOHww&ixlib=rb-4.1.0&q=85&w=1000",
    alt: "Chrome engine detail",
  },
  {
    src: "https://images.unsplash.com/photo-1620223200930-2e719f329f07?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwxfHxtb3RvcmN5Y2xlJTIwd2hlZWwlMjByaW0lMjBkYXJrfGVufDB8fHx8MTc4NjkxNjYxOXww&ixlib=rb-4.1.0&q=85&w=1000",
    alt: "Motorcycle wheel and drivetrain",
  },
  {
    src: "https://images.unsplash.com/photo-1673296012209-c048b23860e5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwyfHxnbG9zc3klMjBtb3RvcmN5Y2xlJTIwcGFpbnR8ZW58MHx8fHwxNzg2OTE2NjE5fDA&ixlib=rb-4.1.0&q=85&w=1000",
    alt: "Glossy paint reflection",
  },
  {
    src: "https://images.unsplash.com/photo-1636761358756-ef34b4ef036a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwzfHxtb3RvcmN5Y2xlJTIwZGV0YWlsaW5nfGVufDB8fHx8MTc4NjkxNjYwOHww&ixlib=rb-4.1.0&q=85&w=1000",
    alt: "Hands detailing a motorcycle",
  },
  {
    src: "https://images.unsplash.com/photo-1653654299266-13d03a47502d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwzfHxtb3RvcmN5Y2xlJTIwd2hlZWwlMjByaW18ZW58MHx8fHwxNzg2OTE2NjE5fDA&ixlib=rb-4.1.0&q=85&w=1000",
    alt: "Spoked wheel close up",
  },
  {
    src: "https://images.unsplash.com/photo-1599905284419-ec448ed606b9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwxfHxtb3RvcmN5Y2xlJTIwZW5naW5lfGVufDB8fHx8MTc4NjkxNjYwOHww&ixlib=rb-4.1.0&q=85&w=1000",
    alt: "Engine block detail",
  },
  {
    src: "https://images.unsplash.com/photo-1656420731047-3eb41c9d1dee?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwyfHxjaW5lbWF0aWMlMjBtb3RvcmN5Y2xlfGVufDB8fHx8MTc4NjkxNjYwOHww&ixlib=rb-4.1.0&q=85&w=1000",
    alt: "Detailed motorcycle in studio",
  },
  {
    src: "https://images.unsplash.com/photo-1560091447-b929b62ffbde?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHw0fHxtb3RvcmN5Y2xlJTIwcmltfGVufDB8fHx8MTc4NjkxNjYxOXww&ixlib=rb-4.1.0&q=85&w=1000",
    alt: "Front rim and brake detail",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "I've never seen my bike look this good — not even the day I bought it. The finish is genuinely showroom quality.",
    name: "James W.",
    bike: "Triumph Bonneville T120",
    rating: 5,
  },
  {
    quote:
      "Carlos treats every bike like it's his own. The attention to the small details is on another level.",
    name: "Ari M.",
    bike: "Ducati Monster 821",
    rating: 5,
  },
  {
    quote:
      "Booked the maintenance detail and now I won't take my Harley anywhere else. Immaculate work, every time.",
    name: "Dylan R.",
    bike: "Harley-Davidson Fat Bob",
    rating: 5,
  },
];
